import { IGetAllManutencaoUseCase } from "../../../presentation/useCases/read/get_all_manutencao_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { ManutencaoLista } from "../../models/manutencao_lista";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * GetAllManutencaoUseCase
 */

export class GetAllManutencaoUseCase extends BasePaginatedUseCase<ManutencaoLista> implements IGetAllManutencaoUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) {
    super();
  }

  async execute(
    nroManutencao?: number,
    idsMaquinaEquip?: number[],
    idsCentroCusto?: number[],
    idsFuncionarioSolicitante?: number[],
    idsFuncionarioAprovacao?: number[],
    idsFornecedorResponsavel?: number[],
    dataSolicitacaoDe?: Date,
    dataSolicitacaoAte?: Date,
    status?: string[],

    currentPage?: number,
    rowsPerPage?: number
  ): Promise<void> {
    const result = await this.repository.getAllListagemManutencao(
      nroManutencao,
      idsMaquinaEquip,
      idsCentroCusto,
      idsFuncionarioSolicitante,
      idsFuncionarioAprovacao,
      idsFornecedorResponsavel,
      dataSolicitacaoDe,
      dataSolicitacaoAte,
      status,
      currentPage,
      rowsPerPage
    );

    this._items = result.items;
    this._totalItems = result.totalItems;
    this._totalPages = result.totalPages;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;
  }
}
